import { useState, useRef, useEffect, useReducer, useContext } from 'react';
import './BiometricIDInstall.scss';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import download from '../../../../../assets/icons/download-white.svg';
import checkmark from '../../../../../assets/icons/checkmark-white.svg';
import install from '../../../../../assets/img/install.gif';
import insert from '../../../../../assets/img/insert.gif';
import attach from '../../../../../assets/img/attach.gif';
import portrait from '../../../../../assets/icons/icon-recognition.svg';
import Ajax from '../../../../../Handler/Ajax';
import Toast from '../../../../Form/Toast';
import GovSpinner from '../../../../Form/GovSpinner';
// import ReCAPTCHA from 'react-google-recaptcha';
import SubmitBtn from '../../../../Form/submit-button/submit-button.component';
import eye from '../../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../../assets/icons/outline_eye_bright-off.svg';
import moviePlayer from '../../../../../assets/icons/movie-player.svg';
import externalLink from '../../../../../assets/icons/external-link-blue.svg';
import alertYellow from '../../../../../assets/icons/alert-circle-yellow.svg';
import LoginContext from '../../../../../store/login-context';


declare var _siteSettings: any;
declare function Translate(key: string): string;
declare var _curLang: any;

const stepsReducer = (state, action) => {
  if(action.type === 'FIRST_STEP_DONE'){
    return {
      step1: {
        inactive: false,
        active: false,
        done: true
      },
      step2: {
        inactive: false,
        active: true,
        done: false,
      },
      step3: state.step3,
      step4: state.step4
    }
  }
  if(action.type === 'SECOND_STEP_DONE'){
    return {
      step1: state.step1,
      step2: {
        inactive: false,
        active: false,
        done: true
      },
      step3: {
        inactive: false,
        active: true,
        done: false
      },
      step4: state.step4
    }
  }
  if(action.type === 'THIRD_STEP_DONE'){
    return {
      step1: state.step1,
      step2: state.step2,
      step3: {
        inactive: false,
        active: false,
        done: true
      },
      step4: {
        inactive: false,
        active: true,
        done: false
      }
    }
  }
  if(action.type === 'FOURTH_STEP_DONE'){
    return {
      step1: state.step1,
      step2: state.step2,
      step3: state.step3,
      step4: {
        inactive: false,
        active: false,
        done: true
      }
    }
  }
};

const digitsReducer = (state, action) => {
  if(action.type === 'FIRST_DIGIT'){
    return{...state, codeDigit1: action.value}    
  }
  if(action.type === 'SECOND_DIGIT'){
    return{...state, codeDigit2: action.value}   
  }
  if(action.type === 'THIRD_DIGIT'){
    return{...state, codeDigit3: action.value}    
  }
  if(action.type === 'FOURTH_DIGIT'){
    return{...state, codeDigit4: action.value}    
  }
};

const BiometricIDInstall = props => {

  const ctx = useContext(LoginContext);

  let _digit1Ref: any = useRef(undefined);
  let _digit2Ref: any = useRef(undefined);
  let _digit3Ref: any = useRef(undefined);
  let _digit4Ref: any = useRef(undefined);
  let _buttonRef: any = useRef(undefined);
  // let recaptchaRef:any = useRef(undefined);

  const [stepsState, dispatchSteps] = useReducer(stepsReducer,{    
      step1: {
        inactive: false,
        active: true,
        done: false,
      },
      step2: {
        inactive: true,
        active: false,
        done: false,
      },
      step3: {
        inactive: true,
        active: false,
        done: false,
      },
      step4: {
        inactive: true,
        active: false,
        done: false,
      },    
  }); 

  const [digitsState, dispatchDigits] = useReducer(digitsReducer,{
    codeDigit1:'',
    codeDigit2:'',
    codeDigit3:'',
    codeDigit4:''
  });

  const [stepImg, setStepImg] = useState(install);
  const [currentStep, setCurrentStep] = useState(1);
  const [idCodeValid, setIdCodeValid] = useState(false);  
  // const [codeNumber, setCodeNumber] = useState('');  
  const [showDialog, setShowDialog] = useState(false);
  const [serverMessage, setServerMessage] = useState('');
  const [loading, setLoading] = useState(false);  
  const [userId, setUserId] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [readerOff, setReaderOff] = useState(false);
  const [controlPassType, setControlPassType] = useState('password');
  const [isCardRemoved, setIsCardRemoved] = useState(false);
  const [isComponentLoaded, setIsComponentLoaded] = useState(false);

  useEffect(() => {
    if(ctx.devMode){
      setTimeout(() => firstStepDone(),1000);      
    }
    else{
      CheckInstalled();    
    }   
  },[]);  

  useEffect(() => {
    if(isComponentLoaded){
      checkCodeNumber();
    }
    else{
      setIsComponentLoaded(true);
    }
    
  },[digitsState]);

  useEffect(() => {
    if(idCodeValid === true){
      _buttonRef.current?.focus();
    }
  },[idCodeValid]);

  useEffect(() => {
    if(showDialog){
      document.getElementById('okBtn')?.focus();    
    }
  },[showDialog])

  const downloadClick = () => {
    window.location.href = '/nidp/GOV/agents/SC_and_ID_Install.exe';    
  };

  const bioIdSoftwareDownload = () => {       
    window.location.href = 'https://www.gov.il/files/piba/Smart_Identification-1.1.25.7862.exe';
  }
  
  const firstStepDone = () => {
    dispatchSteps({type:'FIRST_STEP_DONE'});
    setStepImg(attach);
    setCurrentStep(2);    

    if(ctx.devMode){
      setTimeout(() => secondStepDone(),1000);                
    }
  };

  const secondStepDone = () => {
    dispatchSteps({type:'SECOND_STEP_DONE'});
    setStepImg(insert);
    setCurrentStep(3);
    
    if(ctx.devMode){
      setTimeout(() => thirdStepDone(),1000);      
    }
    else{
      GetCard(); 
    }
  }

  const thirdStepDone = () => {
    dispatchSteps({type:'THIRD_STEP_DONE'});
    setStepImg(install);
    setCurrentStep(4);
    
    if(ctx.devMode){
      setTimeout(() => fourthStepDone(),1000);        
    }
  };

  const fourthStepDone = () => {
    dispatchSteps({type:'FOURTH_STEP_DONE'});
    setCurrentStep(5);
    setServerMessage('');    
  };

  const CheckInstalled = () => {
    Ajax.CheckInstalled()
      .then(() => {
        firstStepDone();   
        CheckAgent();
      })
      .catch(() => {
        setTimeout(CheckInstalled, 500);
      });
  };

  const CheckAgent = () => {
    Ajax.CheckAgent()
      .then(() => {
        secondStepDone();   
        startListenReaderRemove();
      })
      .catch(() => {
        setTimeout(CheckAgent, 500);
      });
  };

  const startListenReaderRemove = () => {
    Ajax.CheckReaderOff()
      .then(() => {
        setReaderOff(true);
        setServerMessage(Translate('N_General_Error_card reader_REMOVED'));        
        firstStepDone();
      })
      .catch(() => {
        if (readerOff) {
          setReaderOff(false);
          setServerMessage(Translate(''));          
        }
        setTimeout(startListenReaderRemove, 500);
      });
  };

  const GetCard = () => {
    Ajax.CheckCard()
      .then(() => {
        if(isCardRemoved){
          setIsCardRemoved(false);
          setServerMessage('');                   
        }
        thirdStepDone();        
        startListenCardremove();
        GetCardCertificat();
      })
      .catch(() => {
        setTimeout(GetCard, 500);
      });
  };

  const GetCardCertificat = () => {
    Ajax.GetCardCertificate()
      .then((data: any) => {
        //create custom event id for glassbox        
        if(data.userId.length === 9){         
            const gbDetector = window['_detector']; 
            if(gbDetector){
                gbDetector.triggerCustomEvent('userIsraeliIdLogin', data.userId);
            }
        }
        setUserId(data.userId);
        setFirstName(data.firstName);
        setLastName(data.lastName);               
        fourthStepDone();      
      })
      .catch((error) => {
        if(error.toLowerCase().startsWith("n_general_error")){
          setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
        }
        else{
          setTimeout(GetCardCertificat, 500);
        }      
      });
  };

  const startListenCardremove = () => {
    Ajax.CheckRemovedCard().then(() => {
      setIsCardRemoved(true);
      setServerMessage(Translate('N_General_Error_CARD_REMOVED_ERROR'));      
      secondStepDone();
    });
  };

  const idCodeCheck = () => {
    if(!idCodeValid)  return;

    setLoading(true);
    setServerMessage('');    
    if (idCodeValid) {
      var idCode = `${digitsState!.codeDigit1}${digitsState!.codeDigit2}${digitsState!.codeDigit3}${digitsState!.codeDigit4}`;
      // setCodeNumber(idCode);      

      if (ctx.devMode) {
        let neededInfo = [
          'email',
          'mobile',
          'password',
          'prefferedContactMethods',
        ];
        props.onProcessFinished(neededInfo);
      } else {
        Ajax.SignDummyChallange(idCode)
          .then(() => {
            // recaptchaRef.current.execute();
            onSolve(idCode);
          })
          .catch((error) => {  
            setLoading(false);
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));            
          });
      }
    }
  };

  const setDigitInputFocus = (currentInput: string) => {
    switch (currentInput) {
      case 'codeDigit1':
        _digit2Ref.current?.focus();
        break;
      case 'codeDigit2':
        _digit3Ref.current?.focus();
        break;
      case 'codeDigit3':
        _digit4Ref.current?.focus();
        break;

      default:
        break;
    }
  };

  const codeDigitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{1}$/;

    if (regex.test(event.target.value.toString())) {
      if(event.target.name === 'codeDigit1'){
        setDigitInputFocus(event.target.name);
        dispatchDigits({type: 'FIRST_DIGIT', value: event.target.value});                    
      }
      else if (event.target.name === 'codeDigit2'){
        setDigitInputFocus(event.target.name);    
        dispatchDigits({type: 'SECOND_DIGIT', value: event.target.value});              
      }
      else if (event.target.name === 'codeDigit3'){
        setDigitInputFocus(event.target.name);
        dispatchDigits({type: 'THIRD_DIGIT', value: event.target.value});                 
      }
      else if (event.target.name === 'codeDigit4'){
        dispatchDigits({type: 'FOURTH_DIGIT', value: event.target.value}); 
        setDigitInputFocus(event.target.name);               
      }
    }
    else {
      if(event.target.name === 'codeDigit1'){
        dispatchDigits({type: 'FIRST_DIGIT', value: ''});                  
      }
      else if (event.target.name === 'codeDigit2'){
        dispatchDigits({type: 'SECOND_DIGIT', value: ''});            
      }
      else if (event.target.name === 'codeDigit3'){
        dispatchDigits({type: 'THIRD_DIGIT', value: ''});         
      }
      else if (event.target.name === 'codeDigit4'){
        dispatchDigits({type: 'FOURTH_DIGIT', value: ''});           
      }          
    }
  };
  
  const checkCodeNumber = () => {
    if (
      digitsState!.codeDigit1 !== '' &&
      digitsState!.codeDigit2 !== '' &&
      digitsState!.codeDigit3 !== '' &&
      digitsState!.codeDigit4 !== ''
    ) {
      setIdCodeValid(true);      
    } else {
      setIdCodeValid(false);
    }
  };

  const onInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };

  const handleDialogCancle = () => {
    setShowDialog(false);    
  };

  const handleDialogOk = () => {
    setShowDialog(false);
    thirdStepDone();   
  };

  const handleDialogShow = () => {
    setShowDialog(true);    
  };

  // const onExpired = () => {};

  const onSolve = (idCode:string) => {
    Ajax.GetChallangeFromServer()
      .then(() => {
        Ajax.SignChallange(idCode)
          .then(() => {
            Ajax.SendSigServer()
              .then(() => {
                Ajax.onPKILoginEnd()
                  .then((data: any) => {
                    setLoading(false);                    
                    props.onProcessFinished(data.neededInfo);
                  })
                  .catch((error) => {
                    setLoading(false);
                    setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                  });
              })
              .catch((error) => {
                setLoading(false);              
                setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));

                switch (error) {
                  case 'LOGON_PROCESS_EXPIRED':
                  case 'INTRUDER_DETECTED':
                  case 'AUTH_CONFIRM_TIMEOUT':
                  case 'SMARTPHONE_AUTH_REJECTED':
                  case 'SMARTPHONE_INCORRECT_LOCATION':
                  case 'TOTP_LOGON_DISABLED':
                  case 'LOGIN_DISABLED':
                  case 'PKI_LOGON_EXPIRED':
                    thirdStepDone();
                }
              });
          })
          .catch((error) => {
            setLoading(false);    
            setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));            
          });
      })
      .catch((error) => {
        // recaptchaRef.current.reset();
        setLoading(false);  
        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
        
        switch (error) {
          case 'LOGON_PROCESS_EXPIRED':
          case 'INTRUDER_DETECTED':
          case 'AUTH_CONFIRM_TIMEOUT':
          case 'SMARTPHONE_AUTH_REJECTED':
          case 'SMARTPHONE_INCORRECT_LOCATION':
          case 'TOTP_LOGON_DISABLED':
          case 'LOGIN_DISABLED':
          case 'PKI_LOGON_EXPIRED':
            secondStepDone();
        }
      });
  };
  
  const cardEntered = () => {
    if(isCardRemoved){
      setIsCardRemoved(false);
      setServerMessage('');      
    }
    thirdStepDone();
    GetCardCertificat();
  }

  const handleEnter = (event) => {
    if (event.charCode === 13) {
      idCodeCheck();
    }
  }

  return (
    <Container fluid>
      {/* <div>
        <ReCAPTCHA
          ref={recaptchaRef as any}
          sitekey={_siteSettings.recaptchaSiteKey}
          onChange={onSolve}
          onExpired={onExpired}
          size='invisible'
        />
      </div> */}

      {serverMessage.length > 0 && (
        <Row>
          <Col xs={10}>
            <Toast message={serverMessage} />
          </Col>
        </Row>
      )}

      <GovSpinner show={loading} />

      {currentStep !== 5 ? (
        <Row className='d-flex justify-content-center'>
        <Col xl={7} lg={12} md={12} sm={12} xs={12}>
          <Row className='x-large form-font' role="heading" aria-level={2}>
            {Translate('N_Login_Bio_ID_software_installation_title')}
          </Row>
          <Row className='regular form-font'>
            {Translate('N_Login_Bio_ID_software_installation_info')}
          </Row>
          <Row
            className={
              stepsState!.step1.active
                ? 'mt-4 align-items-start'
                : 'mt-4 align-items-center'
            }
          >
            <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
              {stepsState!.step1.active ? (
                <div className='circle-step'>1</div>
              ) : stepsState!.step1.inactive ? (
                <div className='circle-step-inactive'>1</div>
              ) : (
                <div className='circle-step-succeeded'>
                  <span className='checkmark-icon'>
                    <img src={checkmark}  />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={11}>
              <Row
                className={
                  stepsState!.step1.active
                    ? 'font-active-step-title'
                    : 'form-font-inactive'
                }
              >                  
                {Translate('N_Login_Bio_ID_software_installation_step_1')}
              </Row>
              {stepsState!.step1.active ? (
                <>
                  <Row className='regular font-active-step-text'>                    
                    {Translate(
                      'N_Login_Bio_ID_software_installation_step_1_info_id'
                    )}
                  </Row>
                  <Row>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className='pe-0 pt-2'
                    >
                      <button
                        type='button'
                        id='downloadNetIqSoftBtn'
                        className='download_btn'
                        onClick={downloadClick}
                      >
                        <span className='icon_container'>
                          <img src={download} aria-hidden="true" />
                        </span>
                        <span>
                          {Translate(
                            'N_Login_Bio_ID_software_installation_button'
                          )}
                        </span>
                      </button>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
          <Row className='mt-4 align-items-center'>
            <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
              {stepsState!.step2.active ? (
                <div className='circle-step'>2</div>
              ) : stepsState!.step2.inactive ? (
                <div className='circle-step-inactive'>2</div>
              ) : (
                <div className='circle-step-succeeded'>
                  <span className='checkmark-icon'>
                    <img src={checkmark}  />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={11}>
              {stepsState!.step2.active ? (
                <>
                  <Row className='font-active-step-title'>                   
                    {Translate(
                      'N_Login_Bio_ID_software_installation_step_2'
                    )}
                  </Row>
                  <Row className='regular font-active-step-text'>                   
                    {Translate(
                      'N_Login_Bio_ID_software_installation_step_2_info'
                    )}
                  </Row>
                </>
              ) : (
                <Row className='regular form-font-inactive '>                    
                  {Translate('N_Login_Bio_ID_software_installation_step_2')}
                </Row>
              )}
            </Col>
          </Row>
          <Row
            className={
              stepsState!.step3.active
                ? 'mt-4 align-items-start'
                : 'mt-4 align-items-center'
            }
          >
            <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
              {stepsState!.step3.active ? (
                <div className='circle-step'>3</div>
              ) : stepsState!.step3.inactive ? (
                <div className='circle-step-inactive'>3</div>
              ) : (
                <div className='circle-step-succeeded'>
                  <span className='checkmark-icon'>
                    <img src={checkmark}  />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={11}>
              <Row
                className={
                  stepsState!.step3.active
                    ? 'font-active-step-title'
                    : 'regular form-font-inactive'
                }
              >                  
                {Translate('N_Login_Bio_ID_software_installation_step_3')}
              </Row>
              {stepsState!.step3.active ? (
                <>
                  <Row className='regular font-active-step-text'>                   
                    {Translate(                       
                      'N_Login_Bio_ID_software_installation_step_3_info'
                    )}
                  </Row>
                  <Row>
                    <Col
                      xl={5}
                      lg={5}
                      md={5}
                      sm={12}
                      xs={12}
                      className='pe-0 pt-2'
                    >
                      <button
                        id='insertIdCardBtn'
                        type='button'
                        className='download_btn'
                        onClick={cardEntered}
                      >                           
                        <span>                            
                          {Translate(                             
                            'N_Login_Bio_ID_software_installation_step_3_butten'
                          )}
                        </span>
                      </button>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
          <Row className={'mt-4 ' + 
              (stepsState!.step4.active
                ? 'align-items-start'
                : 'align-items-center' )
            }>
            <Col xs={1} className='step pe-0 pt-1' aria-hidden="true">
              {stepsState!.step4.active ? (
                <div className='circle-step'>4</div>
              ) : stepsState!.step4.inactive ? (
                <div className='circle-step-inactive'>4</div>
              ) : (
                <div className='circle-step-succeeded'>
                  <span className='checkmark-icon'>
                    <img src={checkmark}  />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={11}>
              <Row
                className={
                  stepsState!.step4.active
                    ? 'font-active-step-title'
                    : 'regular form-font-inactive'
                }
              >                
                {Translate('N_Login_Bio_ID_software_installation_step_4')}
              </Row>
              {stepsState!.step4.active ? (
                <>
                <Row className='regular install-desc'>
                  {Translate('N_Login_Bio_ID_software_installation_step_4_info1')}
                  <a className='link' target='_blank' rel="noreferrer" href='https://www.gov.il/he/departments/guides/software_smartid'>
                    <span className='mx-1 d-flex align-items-center'>{Translate('N_Login_biometric_id_SmartCard_guide')}
                      <img src={externalLink} className='mx-1' width="14px" height="14px" />
                    </span>
                  </a> 
                </Row>                                
                <Row className="install-alert mb-8 py-2"> 
                    <Col xs={1} aria-hidden="true">
                      <img src={alertYellow} />
                    </Col>
                    <Col xs={10}>
                      {Translate('N_Login_Bio_ID_software_installation_step_4_info2')}
                    </Col>                        
                </Row>
                <Row>
                  <Col
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className={
                      (_curLang === 'en' || _curLang === 'ru'
                          ? 'ps-0 '
                          : 'pe-0 ') + 'mt-2'
                    }                          
                  >
                    <button
                      type='button'
                      id='downloadBioIdBtn'
                      className='download_btn'
                      onClick={bioIdSoftwareDownload}
                    > 
                      <span className='icon_container' aria-hidden="true">
                        <img src={download}  width='13.3px' height='16px' />
                      </span>                         
                      <span>                            
                        {Translate(
                          'N_Login_Bio_ID_software_installation_button'
                        )}
                      </span>                        
                    </button>
                  </Col>
                </Row>
                <Row className="d-flex flex-row justify-content-start align-items-center mt-4 smart-card-movie" aria-hidden="true">
                  <img src={moviePlayer} width="20px" height="14px" />&nbsp;&nbsp;
                  <a href='https://youtu.be/uwQPK-G7VC8' target='_blank' rel="noopener noreferrer" className='regular'>                
                    {Translate('N_General_watch_tutorial')}
                  </a> 
                </Row> 
                </>
              ):null}
            </Col>
          </Row>                                    
          <Row aria-hidden="true">
            <Col xl={10} lg={10} md={10} sm={12} xs={12} className='mt-5'>
              <img
                src={stepImg}
                alt=''
                height='300px'
                width='100%'                
              />
            </Col>
          </Row>           
        </Col>
      </Row>
      ) : (
        <>
          <Row className='d-flex justify-content-center'>
            <Col xl={8} lg={8} md={8} sm={12} xs={12}>
              <div className='text-center '>
                <img src={portrait}  aria-hidden="true"/>
              </div>
              <div className='x-large dark-blue text-center font-weight-bold' role="heading" aria-level={1}>
                {Translate('N_Login_Bio_ID_name title')}{' '}
                {/* {`${firstName} ${lastName}`} */}
              </div>
              <div className='regular dark-blue text-center'>
                {Translate('N_Login_Bio_ID_OTP_info_1')} {userId}
              </div>
              <div id='idCodeTitle' className='medium dark-blue text-center mt-3 font-weight-500'>
                {Translate('N_Login_Bio_ID_OTP_info_2')}
              </div>
              <Form>
                <Row
                  aria-labelledby = "idCodeTitle"
                  className={
                    (_curLang === 'en' || _curLang === 'ru'
                      ? ' flex-row'
                      : ' flex-row-reverse') + ' justify-content-around mt-3'
                  }
                >                                    
                  <div aria-hidden="true"
                      className={
                        (_curLang === 'en' || _curLang === 'ru'
                          ? ' justify-content-end'
                          : ' justify-content-start') + ' col-3 d-flex align-items-center'
                      }
                      onClick={() =>
                        setControlPassType(
                          controlPassType === 'password'
                            ? 'text'
                            : 'password'
                        )
                      }
                    >
                      <img
                        src={controlPassType === 'password' ? eye : eyeOff}
                        width='22px'
                        height='18px'
                        
                        role='button'
                        tabIndex={0}
                        className='password-view-show'                        
                      />
                      <span 
                        className='password-view-show'
                      >
                        {controlPassType === 'password' 
                          ? Translate('N_General_SignUp_info_18')
                          : Translate('N_General_SignUp_info_19')
                        }
                      </span>                      
                    </div>
                  <Form.Control
                    ref={_digit1Ref}
                    id='codeDigit1'
                    aria-required="true"
                    name='codeDigit1'
                    type={controlPassType}
                    autoComplete='off'
                    value={digitsState!.codeDigit1}
                    onChange={codeDigitChange}
                    onFocus={onInputFocus}
                    onKeyPress={handleEnter}                      
                    className='id-code-box large font-weight-500 gov-black'
                    style={{ textAlign: 'center' }}
                  ></Form.Control>
                  <Form.Control
                    ref={_digit2Ref}
                    id='codeDigit2'
                    aria-required="true"
                    name='codeDigit2'
                    type={controlPassType}
                    autoComplete='off'
                    value={digitsState!.codeDigit2}
                    onChange={codeDigitChange}
                    onFocus={onInputFocus}
                    onKeyPress={handleEnter}
                    className='id-code-box large font-weight-500 gov-black'
                    style={{ textAlign: 'center' }}
                  ></Form.Control>
                  <Form.Control
                    ref={_digit3Ref}
                    id='codeDigit3'
                    aria-required="true"
                    name='codeDigit3'
                    type={controlPassType}
                    autoComplete='off'
                    value={digitsState!.codeDigit3}
                    onChange={codeDigitChange}
                    onFocus={onInputFocus}
                    onKeyPress={handleEnter}
                    className='id-code-box large font-weight-500 gov-black'
                    style={{ textAlign: 'center' }}
                  ></Form.Control>
                  <Form.Control
                    ref={_digit4Ref}
                    id='codeDigit4'
                    aria-required="true"
                    name='codeDigit4'
                    type={controlPassType}
                    autoComplete='off'
                    value={digitsState!.codeDigit4}
                    onChange={codeDigitChange}
                    onFocus={onInputFocus}
                    onKeyPress={handleEnter}
                    className='id-code-box large font-weight-500 gov-black'
                    style={{ textAlign: 'center' }}
                  ></Form.Control>
                  <Col xs={2}></Col>
                </Row>
                <Row className='justify-content-around mt-5'>
                  <Col xs={8}>                      
                    <SubmitBtn
                      title={Translate('N_Login_Bio_ID_OTP_button_1')}
                      id="bioIdInstallSubmit"
                      action={idCodeCheck}
                      showIcon={false}
                      disabled={!idCodeValid}
                      btnRef={_buttonRef}
                    />
                  </Col>
                </Row>
                <Row className='text-center mt-5'>
                  <Col xs={11}>
                    <Button
                      id = 'changeIdCardBtn'
                      variant='link'
                      onClick={handleDialogShow}
                      className='regular font-weight-500'                      
                    >
                      {Translate('N_Login_Bio_ID_OTP_button_2')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>

          <Modal
            show={showDialog}
            onHide={handleDialogCancle}
          >          
            <Modal.Body>
              <Row>               
                <Col xs={12}>
                  <div className='text-center dialog-title mt-5' role="heading" aria-level={2}>
                    {Translate(
                      'N_Login_Bio_ID_software_installation_error2_title'
                    )}
                  </div>
                  <div className='text-center mt-3 dialog-info'>
                    {Translate(
                      'N_Login_Bio_ID_software_installation_error2_info'
                    )}
                  </div>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className='mb-3'>
              <Col xs={8}>
                <Row>
                  <Button
                    id='okBtn'
                    variant='primary'
                    className='w-100'
                    onClick={handleDialogOk}                    
                  >
                    {Translate('N_Login_Bio_ID_software_installation_error_butten')}
                  </Button>
                </Row>
                <Row className='mt-2'>
                  <Button
                    variant='link'
                    className='w-100'
                    onClick={handleDialogCancle}
                  >
                    {Translate('N_General_cancel_butten')}
                  </Button>
                </Row>
              </Col>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Container>
  );

  
};
export default BiometricIDInstall;

